import React, { useState, useEffect, useCallback } from "react"
import { useSelector, useDispatch } from "react-redux"

import InputRadioCheckbox from "../../shared/input.radio.checkbox"
import { IRedux } from "../../services/types"
import { formatDateOnly } from "../../utils/helper.date"
import { setDaysIdAndNextStep } from "../../redux/inscription"
import { setLoading } from "../../redux/loading"
import UserEventApi from "../../services/api/UserEvent.api"
import { IUser } from "../../interfaces/user"

const Dates = () => {
  const dispatch = useDispatch()

  const userId = useSelector((state: IRedux) => state.inscription.userId)
  const event = useSelector((state: IRedux) => state.event)

  const [daysId, setDaysId] = useState<number[]>([])

  const setCurrentDaysId = useCallback(async () => {
    if (!userId) return
    dispatch(setLoading(true))
    await new UserEventApi().getByUserId(userId).then((u: IUser) => {
      if (u.UserEvent)
        setDaysId(
          u.UserEvent.UserEventDays.filter(ued => ued.registered).map(
            ued => ued.eventDayId
          )
        )
    })
    dispatch(setLoading(false))
  }, [dispatch, userId])

  useEffect(() => {
    setCurrentDaysId()
  }, [setCurrentDaysId])

  return (
    <div>
      <InputRadioCheckbox
        label="Je souhaite m'inscrire pour les dates suivantes :"
        style={{ textAlign: "center", marginBottom: 10 }}
        options={
          event?.EventDays.map(ed => ({
            label: formatDateOnly(ed.day),
            value: ed.id.toString()
          })) || []
        }
        selectedValues={daysId.map(d => d.toString())}
        type="checkbox"
        setSelectedValue={v => {
          const dayId = Number(v)
          const find = daysId.find(d => d === dayId)
          if (find) setDaysId(daysId.filter(d => d !== dayId))
          else setDaysId([...daysId, dayId])
        }}
        isHorizontal
      />
      <div className="buttons is-centered">
        <button
          type="button"
          className="button is-primary"
          onClick={() => dispatch(setDaysIdAndNextStep(daysId))}
          disabled={daysId.length < 1}
        >
          Confirmer mon inscription
        </button>
      </div>
    </div>
  )
}

export default Dates
